import React, { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { BaseNames, getApiErrorMessage, isApiPayloadSuccess } from 'src/marketConnect/helpers'
import { useAppDispatch, useAppSelector } from 'src/redux/storeHooks'
import Platforms from '../../../listing/Platforms'
import { Spinner } from 'react-bootstrap'
import Loader from 'src/utils/Loader'
import { Platform, PlatformDataType } from 'src/interfaces/Platform.interface'
import useAppToast from 'src/hooks/useAppToast'
import { useNavigate } from 'react-router-dom'
import {
  connectPlatformAsync,
  deletePlatformDataAsync,
  fetchConnectedPlatformAsync,
  fetchPlatformsAsync,
  shopifyappUninstallAsync,
} from 'src/redux/actions/platformActions'
import ConnectPlatformModal from '../ConnectPlatformModal'
import PlatformCard from '../PlatformCard'
import clsx from 'clsx'
import { setStepsData } from 'src/redux/slices/tourPopupSlice'
import CommonAlertModal from 'src/utils/modals/CommonAlertModal'
import { fetchSkipSetupAsync, fetchUserAccountDetailsAsync } from 'src/redux/actions/accountActions'
import { useDebounce } from 'src/hooks/useDebounce'
import { Tooltip, Box, Typography, Checkbox, FormControlLabel } from '@mui/material'
import { filterTourPlatforms } from '../../utils/tourPlatformSearch'

const DESTINATION_ALLOWED_NATURES = [
  'SECONDARY',
  'BOTH',
  'ACCOUNTING_SECONDARY',
  'SHIPPING_SECONDARY',
  'ERP_SECONDARY',
] as const
type StepStatus = 'active' | 'inactive' | 'finished'

type TourSteps = {
  stepOne: StepStatus
  stepTwo: StepStatus
  stepThree: StepStatus
}

type TourStep1PropType = {
  // setStepsData: React.Dispatch<React.SetStateAction<TourSteps>>
  setSelectedPlatformId: React.Dispatch<React.SetStateAction<string | undefined>>
}

const TourStep2: FC<TourStep1PropType> = ({ setSelectedPlatformId }) => {
  const { fetchedConnectedPlatformData, fetchedConnectedPlatformLoading, mainStoreData } = useAppSelector(
    (state) => state.fetchConnectedPlatform
  )
  const { shopifyConnectFirstTimeMessageShow, firstTimeMessage } = useAppSelector(
    (state) => state.auth
  )
  const { fetchedUserAccountData } = useAppSelector((state) => state.userAccountData)
  const { stepsData } = useAppSelector(state => state.tourPopup)
  const { connectedPlatformData } = useAppSelector((state) => state.connectedPlatform)
  const [showConnectPlatformModal, setShowConnectPlatformModal] = useState<boolean>(false)
  const [selectedPlatform, setSelectedPlatform] = useState<Platform | null>(null)
  const [ecommercePlatform, setEcommercePlatform] = useState<any>([])
  const [showSettingModal, setShowSettingModal] = useState<boolean>(false)
  const [modalData, setModalData] = useState<PlatformDataType>()
  const [confirmChannelDelete, setConfirmChannelDelete] = useState<boolean>(false)
  const [isSkipping, setIsSkipping] = useState<boolean>(false)
  const [deleting, setDeleting] = useState(false)
  const [confirmSkipOnboarding, setConfirmSkipOnboarding] = useState<boolean>(false)
  const [connectingPlatformId, setConnectingPlatformId] = useState<{
    platformId: number | string | null
    isConnecting: boolean
  }>({ isConnecting: false, platformId: null })
  const [loading, setLoading] = useState(false)  
  const [isConnectedPlatformModal, setIsConnectedPlatformModal] = useState(false);
  const [search, setSearch] = useState('');
  const allowedSources = ['COMMERCIUM', 'WOOCOMMERCE', 'VEEQO', 'QBO', 'PRESTASHOP', 'DISCONNECT', 'BIGCOMMERCE', 'GOOGLE', 'TIKTOK'];
  const debouncedSearch = useDebounce(search, 500);
  const { successToast, warningToast, errorToast } = useAppToast()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const onClickConnect = (platform: Platform) => {
    setSelectedPlatform(platform)
    setShowConnectPlatformModal(true)
  }
  const handleCloseModal = () => {
    setShowConnectPlatformModal(false)
    setSelectedPlatform(null) // Reset selected platform
  }
  useEffect(() => {
    if (search !== debouncedSearch) {
      return
    }

    let cancelled = false
    setLoading(true)

    const trimmedSearch = debouncedSearch.trim()
    const query = trimmedSearch.length > 0 ? {search: trimmedSearch} : undefined

    dispatch(fetchPlatformsAsync(query))
      .unwrap()
      .then((res) => {
        if (cancelled) {
          return
        }
        setEcommercePlatform(
          filterTourPlatforms(res?.data, DESTINATION_ALLOWED_NATURES, debouncedSearch)
        )
        setIsConnectedPlatformModal(true)
        setLoading(false)
      })
      .catch(() => {
        if (cancelled) {
          return
        }
        setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [debouncedSearch, search, dispatch]);


  return (
    <>
      <button
        style={{position: 'relative', left: '77rem'}}
        className='btn btn-sm btn-primary fs-6 fw-bold'
        onClick={() => setConfirmSkipOnboarding(true)}
      >
        Skip Setup
      </button>
      <div className='p-2 px-5 rounded bg-light-info my-2 fs-5 mb-4 text-center'>
        <i className='bi bi-telephone-fill fw-bold text-primary fs-5'></i> Facing difficulties in
        setup ? book a free assisted demo & onboarding call by Clicking{' '}
        <a
          className='fw-bold'
          target='_blank'
          href='https://calendly.com/d/crrg-dfq-xkv/product-demo-integration-flow-discussion'
          rel='noreferrer'
        >
          Here
        </a>
      </div>
      <div className='d-flex align-items-center justify-content-between'>
        <h4>
          {connectingPlatformId.isConnecting ? (
            ''
          ) : (
            <>
              <h5 className='mb-0 fw-semibold text-dark'>
                Connect {BaseNames.SECONDARY_Name} Channel
              </h5>
              <Tooltip
                placement='top'
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: '#333',
                      color: '#fff',
                      fontSize: 13,
                      p: 2,
                      borderRadius: 1.5,
                      boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                      maxWidth: 520,
                      position: 'relative',
                      left: {xs: 0, sm: '5.2rem'},
                      bottom: '-12px',
                    },
                  },
                  arrow: {
                    sx: {
                      color: '#333',
                    },
                  },
                }}
                title={
                  <Box sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1.5}}>
                    <Box sx={{p: 1.5, flex: 1, minWidth: 260}}>
                      <Typography fontWeight={700} mb={1}>
                        A Destination platform allows you to send below data from itself to other connected platform that you connect here:
                      </Typography>
                      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
                        {[
                          'Orders',
                          'Customers',
                          'Payments',
                          'Invoices',
                          'Payout Settlements',
                          'Cancellations',
                          'Returns/Refunds',
                        ].map((item) => (
                          <FormControlLabel
                            key={item}
                            control={
                              <Checkbox
                                size='small'
                                checked
                                disabled
                                sx={{
                                  p: 0.3,
                                  '&.Mui-disabled': {color: '#22c55e'},
                                  '&.Mui-checked.Mui-disabled': {color: '#22c55e'},
                                }}
                              />
                            }
                            label={<Typography variant='body2'>{item}</Typography>}
                            sx={{m: 0}}
                          />
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{p: 1.5, flex: 1, minWidth: 260}}>
                      <Typography fontWeight={700} mb={1}>
                        You will be able to receive below data from other platform to this Destination platform:
                      </Typography>
                      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
                        {[
                          'Products',
                          'Inventories',
                          'Price Updates',
                          'Shipments',
                        ].map((item) => (
                          <FormControlLabel
                            key={item}
                            control={
                              <Checkbox
                                size='small'
                                checked
                                disabled
                                sx={{
                                  p: 0.3,
                                  '&.Mui-disabled': {color: '#22c55e'},
                                  '&.Mui-checked.Mui-disabled': {color: '#22c55e'},
                                }}
                              />
                            }
                            label={<Typography variant='body2'>{item}</Typography>}
                            sx={{m: 0}}
                          />
                        ))}
                      </Box>
                    </Box>
                  </Box>
                }
              >
                <Box className='d-flex align-items-center gap-2 mt-2 ms-1' sx={{cursor: 'pointer'}}>
                  <Typography variant='body2' color='text.secondary' sx={{mt: 0.2}}>
                    What is {BaseNames.SECONDARY_Name} Channel?
                  </Typography>
                  <i className='bi bi-info-circle fs-5 text-secondary'></i>
                </Box>
              </Tooltip>
            </>
          )}
        </h4>
        {/* {
            ['COMMERCIUM','WOOCOMMERCE'].includes(fetchedUserAccountData?.source!) ?
            <button type='button' className='btn btn-sm btn-primary fs-6 fw-bold' 
              onClick={()=>{
                  dispatch(setStepsData({stepData:stepsData,visible:false}))
                  navigate('/pricing')
                }} > <i className={'bi bi-coin fs-4 me-2'}></i> Manage Plan</button>
            : null
          } */}
        {isConnectedPlatformModal && (
          <div style={{display: 'flex', gap: 10}}>
            <div className='position-relative w-350px'>
              <span className='search-icon'>
                <i className='fas fa-search' />
              </span>
              <input
                className='form-control ps-5 py-2 text-gray  input-sm'
                type='search'
                placeholder='Search Channels'
                onChange={(e) => setSearch(e.target.value)}
                value={search}
              />
            </div>
          </div>
        )}
      </div>
      <div className='py-4'>
        <div
          className={clsx(
            'row g-3 gx-2 g-xl-8',
            connectingPlatformId.isConnecting ? 'justify-content-center' : ''
          )}
        >
          {/* loader added */}
          {loading ? (
            <div className='text-center py-10'>
              <Loader variant="section" />
            </div>
          ) : ecommercePlatform?.length > 0 ? (
            ecommercePlatform.map((item: Platform) => {
              if (connectingPlatformId.isConnecting) {
                if (connectingPlatformId.platformId === item.id) {
                  return (
                    <PlatformCard
                      key={item.id}
                      data={item}
                      onClickConnectTop={setConnectingPlatformId}
                      // setStepsData={setStepsData}
                      setSelectedPlatformId={setSelectedPlatformId}
                      setIsConnectedPlatformModal={setIsConnectedPlatformModal}
                    />
                  )
                }
                return null // Add this to avoid undefined return
              } else {
                return (
                  <PlatformCard
                    key={item.id}
                    data={item}
                    onClickConnectTop={setConnectingPlatformId}
                    // setStepsData={setStepsData}
                    setSelectedPlatformId={setSelectedPlatformId}
                    setIsConnectedPlatformModal={setIsConnectedPlatformModal}
                  />
                )
              }
            })
          ) : (
            <div className='p-4 bg-light-primary'>
              <h5>We couldn't find any platform matching your search</h5>
            </div>
          )}
        </div>
      </div>

      <CommonAlertModal
        key={'Skip Onboarding Confirmation'}
        title={
          'This Onboarding process guide you to do setup by showing steps, Are you sure you want to skip this & explore on your own?'
        }
        subtitle=''
        isTermsVisible={false}
        successBtnTitle={isSkipping ? 'Updating...' : 'Yes, Skip it.'}
        cancelBtnTitle={'Cancel'}
        successDisabled={isSkipping}
        showCloseButton={true}
        modalClassName='custmd'
        isVisible={confirmSkipOnboarding}
        onCancel={() => {
          setConfirmSkipOnboarding(false)
        }}
        onSuccess={async () => {
          setIsSkipping(true)
          const response = await dispatch(fetchSkipSetupAsync())
          if (response?.payload?.status_code === 200) {
            dispatch(fetchUserAccountDetailsAsync())
            navigate('/dashboard')
          }
        }}
      />

      <CommonAlertModal
        key={'Delete Channel Confirmation'}
        title={'Are you sure, you want to disconnect the connected channel?'}
        modalClassName='custmd'
        subtitle=''
        successDisabled={deleting}
        isTermsVisible={false}
        successBtnTitle={deleting ? 'Disconnecting...' : 'Yes Disconnect'}
        isVisible={confirmChannelDelete}
        onCancel={() => {
          setConfirmChannelDelete(false)
        }}
        onSuccess={async () => {
          const platformId = fetchedConnectedPlatformData[0]?.id
          if (!platformId) {
            warningToast('Channel id is undefined.')
            return
          }

          setDeleting(true)
          try {
            const response = await dispatch(deletePlatformDataAsync({id: platformId}))
            if (isApiPayloadSuccess(response)) {
              await dispatch(fetchConnectedPlatformAsync())
              successToast('Channel disconnected successfully!')
              dispatch(
                setStepsData({
                  stepData: {stepOne: 'active', stepTwo: 'inactive', stepThree: 'inactive'},
                  visible: true,
                })
              )
            } else {
              warningToast(getApiErrorMessage(response, 'Channel not disconnected'))
            }
          } finally {
            setDeleting(false)
            setConfirmChannelDelete(false)
          }
        }}
      />
    </>
  )
}

export default TourStep2

